/* sm-custom-studio.js
   Custom pieces studio on /pages/custom (snippets/sm-custom-studio.liquid).
   1. Loads the collection's models from sections/sm-custom-list.liquid,
      page by page, in the collection's sort order.
   2. Builds a tab per custom.custom_group present and a carousel of cards.
   3. Loads the chosen model's panel from sections/sm-custom-panel.liquid
      and mounts its configurator (SMCfg) and showcase (SMKB).
   ?model=<handle> opens that model and is kept in sync for sharing. */
(function () {
  if (window.SMStudio) return;

  var GROUP_ORDER = ['Sleepers', 'Recliners', 'DayDreamer', 'Accessories'];
  var MAX_PAGES   = 20;

  function withSection(url, sectionId) {
    var u = new URL(url, window.location.origin);
    u.searchParams.set('section_id', sectionId);
    return u.pathname + u.search;
  }

  function loadList(collection) {
    var items = [];
    var pages = 0;
    function page(url) {
      pages++;
      return fetch(withSection(url, 'sm-custom-list'))
        .then(function (r) { if (!r.ok) throw new Error('list ' + r.status); return r.text(); })
        .then(function (html) {
          var doc  = new DOMParser().parseFromString(html, 'text/html');
          var node = doc.querySelector('script[data-sm-studio-list]');
          var data = JSON.parse(node ? node.textContent : '{}');
          items = items.concat(data.items || []);
          if (data.next && pages < MAX_PAGES) return page(data.next);
        });
    }
    return page('/collections/' + encodeURIComponent(collection)).then(function () { return items; });
  }

  function mount(root) {
    if (!root || root.getAttribute('data-sm-studio-mounted') === '1') return;
    root.setAttribute('data-sm-studio-mounted', '1');

    var tabsEl  = root.querySelector('[data-sm-studio-tabs]');
    var trackEl = root.querySelector('[data-sm-studio-track]');
    var panelEl = root.querySelector('[data-sm-studio-panel]');
    var prevBtn = root.querySelector('[data-sm-studio-prev]');
    var nextBtn = root.querySelector('[data-sm-studio-next]');
    var collection = root.getAttribute('data-collection') || 'custom-program';

    var groups       = {};   // group -> [items]
    var groupNames   = [];
    var byHandle     = {};
    var currentGroup = null;
    var currentModel = null;
    var panelCache   = {};
    var requested    = null;

    function status(text) {
      trackEl.innerHTML = '';
      var p = document.createElement('p');
      p.className = 'sm-studio-status';
      p.textContent = text;
      trackEl.appendChild(p);
    }

    function renderTabs() {
      tabsEl.innerHTML = '';
      groupNames.forEach(function (g) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'sm-studio-tab' + (g === currentGroup ? ' is-active' : '');
        b.setAttribute('role', 'tab');
        b.setAttribute('aria-selected', g === currentGroup ? 'true' : 'false');
        b.textContent = g;
        b.addEventListener('click', function () {
          if (g === currentGroup) return;
          showGroup(g);
          selectModel(groups[g][0].handle);
        });
        tabsEl.appendChild(b);
      });
      tabsEl.hidden = groupNames.length < 2;
    }

    function renderCards() {
      trackEl.innerHTML = '';
      (groups[currentGroup] || []).forEach(function (item) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'sm-studio-card' + (item.handle === currentModel ? ' is-active' : '');
        b.setAttribute('data-handle', item.handle);
        b.setAttribute('aria-pressed', item.handle === currentModel ? 'true' : 'false');
        var frame = document.createElement('span');
        frame.className = 'sm-studio-card-img';
        if (item.image) {
          var img = document.createElement('img');
          img.src = item.image;
          img.alt = item.alt || item.name;
          img.loading = 'lazy';
          frame.appendChild(img);
        }
        // Hover swap: the model's first showcase photo fades in over the
        // line art on devices that can hover. Models without photos skip it.
        if (item.hover) {
          var hv = document.createElement('img');
          hv.className = 'sm-studio-card-hover';
          hv.src = item.hover;
          hv.alt = '';
          hv.loading = 'lazy';
          hv.setAttribute('aria-hidden', 'true');
          frame.appendChild(hv);
        }
        var name = document.createElement('span');
        name.className = 'sm-studio-card-name';
        name.textContent = item.name;
        b.appendChild(frame);
        b.appendChild(name);
        b.addEventListener('click', function () { selectModel(item.handle); });
        trackEl.appendChild(b);
      });
      trackEl.scrollLeft = 0;
    }

    function showGroup(g) {
      currentGroup = g;
      renderTabs();
      renderCards();
    }

    function markActiveCard() {
      Array.prototype.forEach.call(trackEl.querySelectorAll('.sm-studio-card'), function (c) {
        var on = c.getAttribute('data-handle') === currentModel;
        c.classList.toggle('is-active', on);
        c.setAttribute('aria-pressed', on ? 'true' : 'false');
        if (on) {
          // Scroll the carousel sideways only. scrollIntoView also scrolls
          // the page, which pulled guests down the page on load.
          var cr = c.getBoundingClientRect(), tr = trackEl.getBoundingClientRect();
          if (cr.left < tr.left || cr.right > tr.right) {
            trackEl.scrollBy({ left: cr.left - tr.left - 8, behavior: 'smooth' });
          }
        }
      });
    }

    function setUrl(handle) {
      try {
        var u = new URL(window.location.href);
        u.searchParams.set('model', handle);
        window.history.replaceState(null, '', u.pathname + u.search + u.hash);
      } catch (e) {}
    }

    function insertPanel(handle, html) {
      if (requested !== handle) return;
      panelEl.innerHTML = html;
      panelEl.classList.remove('is-loading');
      if (window.SMCfg) window.SMCfg.mountAll(panelEl);
      if (window.SMKB) window.SMKB.mountAll(panelEl);
    }

    function selectModel(handle) {
      if (!byHandle[handle]) return;
      currentModel = handle;
      requested = handle;
      markActiveCard();
      setUrl(handle);
      if (panelCache[handle]) { insertPanel(handle, panelCache[handle]); return; }
      panelEl.classList.add('is-loading');
      fetch(withSection('/products/' + encodeURIComponent(handle), 'sm-custom-panel'))
        .then(function (r) { if (!r.ok) throw new Error('panel ' + r.status); return r.text(); })
        .then(function (html) {
          panelCache[handle] = html;
          insertPanel(handle, html);
        })
        .catch(function () {
          if (requested !== handle) return;
          panelEl.classList.remove('is-loading');
          panelEl.innerHTML = '';
          var p = document.createElement('p');
          p.className = 'sm-studio-status';
          p.textContent = 'Sorry, this model did not load. Please pick it again.';
          panelEl.appendChild(p);
        });
    }

    function scrollTrack(dir) {
      trackEl.scrollBy({ left: dir * Math.max(200, trackEl.clientWidth * 0.8), behavior: 'smooth' });
    }
    if (prevBtn) prevBtn.addEventListener('click', function () { scrollTrack(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { scrollTrack(1); });

    loadList(collection)
      .then(function (items) {
        items.forEach(function (item) {
          if (!item || !item.handle || !item.group) return;
          if (!groups[item.group]) groups[item.group] = [];
          groups[item.group].push(item);
          byHandle[item.handle] = item;
        });
        groupNames = Object.keys(groups).sort(function (a, b) {
          var ai = GROUP_ORDER.indexOf(a), bi = GROUP_ORDER.indexOf(b);
          if (ai === -1) ai = 999;
          if (bi === -1) bi = 999;
          return ai - bi;
        });
        if (!groupNames.length) { status('Our custom models are coming soon.'); return; }

        var wanted = null;
        try { wanted = new URL(window.location.href).searchParams.get('model'); } catch (e) {}
        var start = (wanted && byHandle[wanted]) ? byHandle[wanted] : groups[groupNames[0]][0];

        currentModel = start.handle;
        showGroup(start.group);
        selectModel(start.handle);
      })
      .catch(function () { status('Sorry, our custom models did not load. Please refresh the page.'); });
  }

  function mountAll(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-sm-studio]'), mount);
  }

  window.SMStudio = { mountAll: mountAll };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { mountAll(document); });
  } else {
    mountAll(document);
  }

})();
